import React from "react";
import { Trash2, X } from "lucide-react";
import { ModalPortal } from "../../../components/ModalPortal/ModalPortal";
import { CircularProgress } from "../../../components/CircularProgress/CircularProgress";
import { Shimmer } from "../../../components/Shimmer/Shimmer";
import { WEEK_DAYS } from "../requestDetailUtils";

export interface RequestDetailScheduleModalProps {
  hasSchedule: boolean;
  scheduleLoading: boolean;
  scheduleSaving: boolean;
  scheduleDeleting: boolean;
  schedulePeriod: "daily" | "weekly" | "monthly";
  scheduleWeekDay: number;
  scheduleMonthDay: number;
  scheduleMonthLastDay: boolean;
  setSchedulePeriod: React.Dispatch<React.SetStateAction<"daily" | "weekly" | "monthly">>;
  setScheduleWeekDay: React.Dispatch<React.SetStateAction<number>>;
  setScheduleMonthDay: React.Dispatch<React.SetStateAction<number>>;
  setScheduleMonthLastDay: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseScheduleModal: () => void;
  handleSaveSchedule: () => void | Promise<void>;
  handleDeleteSchedule: () => void | Promise<void>;
}

export const RequestDetailScheduleModal: React.FC<RequestDetailScheduleModalProps> = ({
  hasSchedule,
  scheduleLoading,
  scheduleSaving,
  scheduleDeleting,
  schedulePeriod,
  scheduleWeekDay,
  scheduleMonthDay,
  scheduleMonthLastDay,
  setSchedulePeriod,
  setScheduleWeekDay,
  setScheduleMonthDay,
  setScheduleMonthLastDay,
  handleCloseScheduleModal,
  handleSaveSchedule,
  handleDeleteSchedule,
}) => (
  <ModalPortal>
    <div className="detail-schedule-modal-overlay" onClick={handleCloseScheduleModal}>
      <div className="detail-schedule-modal" onClick={(e) => e.stopPropagation()}>
        <div className="detail-schedule-modal-head">
          <h3>{hasSchedule ? "Редактирование расписания" : "Создание расписания"}</h3>
          <button
            type="button"
            className="detail-tasklist-close"
            onClick={handleCloseScheduleModal}
            aria-label="Закрыть расписание"
            disabled={scheduleSaving || scheduleDeleting}
          >
            <X size={18} />
          </button>
        </div>
        <div className="detail-schedule-modal-body">
          {scheduleLoading ? (
            <Shimmer rows={3} />
          ) : (
            <>
              <div className="detail-schedule-form-row">
                <span className="detail-label">Период</span>
                <div className="detail-schedule-period-list">
                  <button
                    type="button"
                    className={`detail-schedule-period-btn ${schedulePeriod === "daily" ? "is-active" : ""}`}
                    onClick={() => setSchedulePeriod("daily")}
                  >
                    Ежедневно
                  </button>
                  <button
                    type="button"
                    className={`detail-schedule-period-btn ${schedulePeriod === "weekly" ? "is-active" : ""}`}
                    onClick={() => setSchedulePeriod("weekly")}
                  >
                    Раз в неделю
                  </button>
                  <button
                    type="button"
                    className={`detail-schedule-period-btn ${schedulePeriod === "monthly" ? "is-active" : ""}`}
                    onClick={() => setSchedulePeriod("monthly")}
                  >
                    Раз в месяц
                  </button>
                </div>
              </div>
              {schedulePeriod === "weekly" && (
                <div className="detail-schedule-form-row">
                  <span className="detail-label">День недели</span>
                  <div className="detail-schedule-weekdays">
                    {WEEK_DAYS.map((d) => (
                      <button
                        key={d.value}
                        type="button"
                        className={`detail-schedule-weekday-btn ${scheduleWeekDay === d.value ? "is-active" : ""}`}
                        onClick={() => setScheduleWeekDay(d.value)}
                      >
                        {d.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {schedulePeriod === "monthly" && (
                <div className="detail-schedule-form-row">
                  <span className="detail-label">Запуск</span>
                  <div className="detail-schedule-monthly">
                    <button
                      type="button"
                      className={`detail-schedule-period-btn ${scheduleMonthLastDay ? "is-active" : ""}`}
                      onClick={() => setScheduleMonthLastDay((prev) => !prev)}
                    >
                      Последний день месяца
                    </button>
                    {!scheduleMonthLastDay && (
                      <div className="detail-schedule-month-days">
                        {Array.from({ length: 31 }, (_, idx) => idx + 1).map((day) => (
                          <button
                            key={day}
                            type="button"
                            className={`detail-schedule-month-day-btn ${
                              scheduleMonthDay === day ? "is-active" : ""
                            }`}
                            onClick={() => setScheduleMonthDay(day)}
                          >
                            {day}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="detail-schedule-modal-actions">
          {hasSchedule && (
            <button
              type="button"
              className="detail-schedule-btn detail-schedule-btn--danger"
              onClick={handleDeleteSchedule}
              disabled={scheduleSaving || scheduleDeleting || scheduleLoading}
            >
              <Trash2 size={16} />
              {scheduleDeleting ? <CircularProgress size="sm" /> : "Удалить"}
            </button>
          )}
          <button
            type="button"
            className="detail-schedule-btn"
            onClick={handleSaveSchedule}
            disabled={scheduleSaving || scheduleDeleting || scheduleLoading}
          >
            {scheduleSaving ? (
              <CircularProgress size="sm" />
            ) : hasSchedule ? (
              "Сохранить"
            ) : (
              "Создать"
            )}
          </button>
        </div>
      </div>
    </div>
  </ModalPortal>
);
